// Remembers which ad brought a visitor (utm_* tags and Meta's fbclid) so it
// can be saved on their account when they sign up, even if that happens
// pages or days later.
const STORAGE_KEY = "vo_attribution";
const MAX_AGE_DAYS = 90;
const UTM_FIELDS = ["source", "medium", "campaign", "content", "term"] as const;

export interface Attribution {
  source?: string;
  medium?: string;
  campaign?: string;
  content?: string;
  term?: string;
  fbclid?: string;
  landingPath?: string;
  referrer?: string;
  capturedAt: string;
}

/** Call once on page load. A new ad click replaces the previous one. */
export const captureAttribution = (url: string = window.location.href) => {
  try {
    const { searchParams, pathname } = new URL(url);
    const found: Partial<Attribution> = {};
    for (const field of UTM_FIELDS) {
      const value = searchParams.get(`utm_${field}`);
      if (value) found[field] = value;
    }
    const fbclid = searchParams.get("fbclid");
    if (fbclid) found.fbclid = fbclid;
    if (!Object.keys(found).length) return;

    // Only keep referrers from other sites.
    const referrer = document.referrer && !document.referrer.includes(window.location.host)
      ? document.referrer
      : undefined;
    const record: Attribution = {
      ...found,
      source: found.source ?? (fbclid ? "facebook" : undefined),
      landingPath: pathname,
      referrer,
      capturedAt: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    // storage blocked or bad URL: attribution is best-effort
  }
};

export const getAttribution = (): Attribution | undefined => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    const record = JSON.parse(raw) as Attribution;
    const ageDays = (Date.now() - new Date(record.capturedAt).getTime()) / 86_400_000;
    return ageDays <= MAX_AGE_DAYS ? record : undefined;
  } catch {
    return undefined;
  }
};
